import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@/core/config/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig).catch((err) => {
    console.error(err);
    document.body.innerHTML = `
        <div style="
            display:flex;align-items:center;justify-content:center;
            min-height:100vh;background:#fafafa;font-family:sans-serif;
        ">
            <div style="
                max-width:480px;width:100%;padding:2rem;border-radius:12px;
                background:#fff;border:1px solid #fca5a5;box-shadow:0 2px 16px rgba(0,0,0,.08);
                text-align:center;
            ">
                <div style="font-size:2.5rem;margin-bottom:1rem;">⚠️</div>
                <h1 style="margin:0 0 .5rem;font-size:1.25rem;color:#dc2626;">Failed to start application</h1>
                <p style="margin:0 0 1rem;color:#6b7280;font-size:.9rem;">
                    Could not load <code style="background:#f3f4f6;padding:2px 6px;border-radius:4px;">app-config.json</code>.
                    Please contact your system administrator.
                </p>
                <pre style="
                    text-align:left;background:#fef2f2;color:#991b1b;padding:1rem;
                    border-radius:8px;font-size:.75rem;overflow:auto;white-space:pre-wrap;
                ">${err?.message ?? err}</pre>
            </div>
        </div>`;
});
